import React from 'react'

interface SmallInfoProps {
  size?: number
  color?: string
  secondColor?: string
}

export const SmallInfo: React.FC<SmallInfoProps> = ({
  size = 28,
  color = '#2970FF',
  secondColor = '#fff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22167_21233)">
        <path
          d="M14 28C6.268 28 0 21.732 0 14S6.268 0 14 0s14 6.268 14 14-6.268 14-14 14zm0-15.4a1.4 1.4 0 00-1.4 1.4v5.6a1.4 1.4 0 102.8 0V14a1.4 1.4 0 00-1.4-1.4zM14 7a1.4 1.4 0 100 2.8A1.4 1.4 0 0014 7z"
          fill={color}
        />
        <path
          d="M14 7a1.4 1.4 0 100 2.8A1.4 1.4 0 0014 7zM14 12.6a1.4 1.4 0 00-1.4 1.4v5.6a1.4 1.4 0 102.8 0V14a1.4 1.4 0 00-1.4-1.4z"
          fill={secondColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_22167_21233">
          <path fill={secondColor} d="M0 0H28V28H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
